import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/leaseterms');
}
//Get all active
export function allActive(){
    return http().get('/leaseterms/active');
}
//Get Single
export function single(id){
    return http().get(`/leaseterms/${id}`);
}
//Add one
export function add(data){
    return http().post('/leaseterms', data)
}
//Update
export function update(id, data){
    return http().put(`/leaseterms/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/leaseterms/${id}`);
}